import {Directive, ElementRef, HostListener, Input, OnInit} from '@angular/core';
import tippy from 'tippy.js';

@Directive({
  selector: '[brtTooltip]'
})
export class TooltipDirective implements OnInit{

  text: string = "";

  theme: string = "default";

  @Input('theme') set setTheme(value: any) {
    if(value) {
      this.theme = value;
    }
  }

  @Input('text') set setText(value: any) {
    this.text = value;

    if(this.text.length) {
      tippy(this.el.nativeElement, {
        content: this.text,
        delay: [100, 100],
        allowHTML: true,
        hideOnClick: true,
        theme: this.theme,
        zIndex: 999999,
        interactive: true,
        aria: {
          content: 'labelledby',
          expanded: true
        },
      })
    }
  }


  constructor(private el: ElementRef) {

  }

  ngOnInit() {

  }
}
